import React, { useState } from 'react';
import WelcomePhase from './WelcomePhase';
import QualitativePhase from './QualitativePhase';
import QuantitativePhase from './QuantitativePhase';
import ResultPhase from './ResultPhase';
import translations from './translations';

const App = () => {
  const [phase, setPhase] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [language, setLanguage] = useState('es');

  const handleNextPhase = () => {
    setPhase(phase + 1);
  };

  const handleCheckboxChange = (question) => {
    if (!question) return;
    setSelectedItems((prevSelectedItems) =>
      prevSelectedItems.includes(question)
        ? prevSelectedItems.filter((item) => item !== question)
        : [...prevSelectedItems, question]
    );
  };

  const handleRestart = () => {
    setPhase(0);
    setSelectedItems([]);
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  const t = translations[language];

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-between">
      <div className="flex justify-between items-center w-full max-w-lg mt-6 mb-4">
        <h1 className="text-4xl font-bold">⚖️ UX Balance</h1>
        <select
          value={language}
          onChange={handleLanguageChange}
          className="ml-4 p-2 border rounded bg-white text-gray-800"
        >
          <option value="es">Español</option>
          <option value="en">English</option>
          <option value="fr">Français</option>
          <option value="de">Deutsch</option>
          <option value="zh">中文</option>
        </select>
      </div>
      <div className="flex-grow flex flex-col items-center">
        {phase === 0 && <WelcomePhase onNext={handleNextPhase} t={t.welcome} />}
        {phase === 1 && <QualitativePhase onNext={handleNextPhase} onChange={handleCheckboxChange} t={t.qualitative} />}
        {phase === 2 && <QuantitativePhase onNext={handleNextPhase} onChange={handleCheckboxChange} t={t.quantitative} />}
        {phase === 3 && <ResultPhase selectedItems={selectedItems} onRestart={handleRestart} t={t.result} />}
      </div>
      <footer className="text-center py-4">
        <p className="text-gray-600">{t.footer.copyright}</p>
        <a
          href="https://www.buymeacoffee.com/lamala"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          {t.footer.buyMeACoffee}
        </a>
      </footer>
    </div>
  );
};

export default App;
